import { useEffect, useState } from 'react';
import { Dialog, useMediaQuery } from '@mui/material';
import { Close } from '@mui/icons-material';
import eventBus from '../../../eventBus';
import LinkedinModalContent from './LinkedinModalContent';

const useStyles = () => ({
  container: {
    borderRadius: '10px',
    boxShadow: '0 5px 20px rgba(0, 0, 0, 0.07)',
    maxWidth: '600px',
    padding: {
      xxs: '48px 0px 0px',
      xs: '30px',
    },
  },
});

export default function LinkedinModal() {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [initialContent, setInitialContent] = useState({});
  const isXS = useMediaQuery((theme) => theme.breakpoints.down('xs'));

  function handleClose() {
    if (isLoading) return;
    setOpen(false);
  }

  useEffect(() => {
    eventBus.on('openLinkedInPostModal', (payload) => {
      if (payload) {
        setInitialContent(payload);
      }
      setOpen(true);
    });
    return () => {
      eventBus.remove('openLinkedInPostModal');
    };
  }, []);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
      fullScreen={isXS}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: classes.container,
      }}
    >
      <Close
        onClick={handleClose}
        sx={{
          position: 'absolute',
          right: '12px',
          top: '12px',
          color: '#4D586F',
          cursor: 'pointer',
        }}
      />
      <LinkedinModalContent
        handleClose={handleClose}
        isLoading={isLoading}
        setIsLoading={setIsLoading}
        initialPostTitle={initialContent.linkedInPostTitle}
        initialPostBody={initialContent.postBody}
        customDescriptionText={initialContent.descriptionText}
        customShareUrl={initialContent.shareUrl}
        customThumbnailUrl={initialContent.shareThumbnailUrl}
        companyName={initialContent.companyName}
        customSuccessMessage={initialContent.customSuccessMessage}
      />
    </Dialog>
  );
}
